import {
    SEND_RESULT_RATING_MAIL_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isResultRatingSendMailLoading = (state) =>
    ArrayContains(state.result.openRequests, [
        SEND_RESULT_RATING_MAIL_REQUEST,
    ]);